import { ArrowBack } from '@mui/icons-material';
import { Grid, Box, AvatarGroup, Avatar, Typography } from '@mui/material';
import { styled } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import { IVendorLists } from 'wisestep-api';
import {
  WsChip,
  WsChipSize,
  WsChipVariants,
  WsColors,
  WsIconJobOutline,
  WsIconPersons,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

const CustomAvatar = styled(Avatar)(() => ({
  width: 20,
  height: 20,
  marginLeft: 1,
}));
interface VendorListBannerProps {
  vendorList?: IVendorLists;
}
const VendorListBanner = ({ vendorList }: VendorListBannerProps) => {
  const navigate = useNavigate();
  return (
    <Box bgcolor={WsColors.TheBlues900} p={2} borderRadius={2}>
      <Grid item container columnGap={1}>
        <ArrowBack
          cursor="pointer"
          sx={{ color: WsColors.White }}
          onClick={() => navigate('/vendors')}
        />
        <Typography fontSize={18} fontWeight="bold" color={WsColors.White}>
          {vendorList?.name ?? ''}
        </Typography>
      </Grid>
      <Grid container item xs={12} pt={1} columnGap={2}>
        <Grid item rowGap={0.5}>
          <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.WHITE}>
            Access
          </WsTypography>
          <WsChip
            size={WsChipSize.SMALL}
            value={vendorList?.type ?? ''}
            variant={WsChipVariants.PRIMARY}
          />
        </Grid>
        {vendorList?.sharedToTeams && vendorList.sharedToTeams?.length > 0 && (
          <Grid item rowGap={1}>
            <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.WHITE}>
              Shared With
            </WsTypography>
            <AvatarGroup sx={{ pt: 1 }}>
              {vendorList?.sharedToTeams?.map((m) => (
                <CustomAvatar alt={m} key={m} />
              ))}
            </AvatarGroup>
          </Grid>
        )}
        <Grid item rowGap={0.5}>
          <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.WHITE}>
            Content Type
          </WsTypography>
          <WsChip
            size={WsChipSize.MEDIUM}
            icon={
              vendorList?.contentType === 'Jobs' ? (
                <Box pl={0.5}>
                  <WsIconJobOutline />
                </Box>
              ) : (
                <Box pl={0.5}>
                  <WsIconPersons />
                </Box>
              )
            }
            value={vendorList?.contentType ?? ''}
            variant={WsChipVariants.PRIMARY}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
export default VendorListBanner;
